// Import necessary libraries and styles
import React, { useEffect, useState, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getFirestore, getDoc, setDoc, doc } from 'firebase/firestore';
import './editbusdetails.css';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Navigate,useNavigate } from 'react-router-dom';

const auth = getAuth();
let currentUser = null;

onAuthStateChanged(auth, (user) => {
  currentUser = user;
});
// Set your Mapbox access token
mapboxgl.accessToken = 'pk.eyJ1IjoidXRrMTIzIiwiYSI6ImNsbnl2cmRicDB5NXcyaXFtNG11dzcwemoifQ.TnZtihEi0MMNGJLyVHoUhQ';

const Collegebus = () => {
  const [map, setMap] = useState(null);
  const markerRef = useRef(null);
  const [cityInput, setCityInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [placeDetails, setPlaceDetails] = useState({
    placeName: '',
    latitude: '',
    longitude: '',
  });
  const [removeIndex, setRemoveIndex] = useState(0);
  const [savedPlaces, setSavedPlaces] = useState([]);
  const [documentId, setDocumentId] = useState('');
  const [isPreviewVisible, setPreviewVisible] = useState(false);
  const [busNumber, setBusNumber] = useState('');
  const [driverMobileNumber, setDriverMobileNumber] = useState('');
  const firestore = getFirestore();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        // If the user is not authenticated, navigate to the login page
        navigate("/login");
      }
    });

    // Cleanup the subscription when the component unmounts
    return () => unsubscribe();
  }, [navigate]);
  const handleMarkerDrag = async () => {
    if (markerRef.current) {
      const { lng, lat } = markerRef.current.getLngLat();
      setPlaceDetails({
        placeName: '',
        latitude: lat.toFixed(4),
        longitude: lng.toFixed(4),
      });

      try {
        // Fetching address based on coordinates
        const addressResponse = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${mapboxgl.accessToken}`
        );
        const addressData = await addressResponse.json();

        if (addressData.features && addressData.features.length > 0) {
          const placeName = addressData.features[0].place_name;
          setPlaceDetails((prevDetails) => ({
            ...prevDetails,
            placeName,
          }));
        }
      } catch (error) {
        console.error('Error fetching address:', error);
      }
    }
  };
  useEffect(() => {
    const initializeMap = () => {
      const newMap = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [76.9214, 15.1394],
        zoom: 13,
      });

      newMap.on('load', () => {
        setMap(newMap);

        const initialMarker = new mapboxgl.Marker({ draggable: true })
          .setLngLat([76.9214, 15.1394])
          .addTo(newMap);

        initialMarker.on('dragend', handleMarkerDrag);
        markerRef.current = initialMarker;
      });

      newMap.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

      return () => newMap.remove();
    };

    initializeMap();
  }, []);

  const handleCityInputChange = async (e) => {
    const inputValue = e.target.value;
    setCityInput(inputValue);

    if (inputValue.trim() !== '') {
      const karnatakaBoundingBox = '74.0509,11.5820,78.1479,18.4682';

      try {
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(inputValue)}.json?access_token=${mapboxgl.accessToken}&bbox=${karnatakaBoundingBox}`
        );
        const data = await response.json();

        const newSuggestions = data.features.map((feature) => ({
          placeName: feature.place_name,
          coordinates: feature.center,
        }));

        setSuggestions(newSuggestions);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
      }
    } else {
      setSuggestions([]);
    }
  };
  const handleSuggestionClick = async (coordinates, placeName) => {
    if (markerRef.current) {
      markerRef.current.setLngLat(coordinates).addTo(map);
      setPlaceDetails({
        placeName,
        latitude: coordinates[1].toFixed(4),
        longitude: coordinates[0].toFixed(4),
      });
      await handleMarkerDrag();
    } else {
      const newMarker = new mapboxgl.Marker({ draggable: true })
        .setLngLat(coordinates)
        .addTo(map);
      newMarker.on('dragend', handleMarkerDrag);
      markerRef.current = newMarker;
    }

    // Move the map to the selected coordinates
    map.flyTo({
      center: coordinates,
      essential: true,
    });

    setCityInput(placeName);
    setSuggestions([]);
  };

  const handleAddButtonClick = () => {
    setSavedPlaces([...savedPlaces, placeDetails]);
    // Show the preview section
    setPreviewVisible(true);
  };

  const handleRemoveButtonClick = () => {
    // Remove the latest added data from the list
    setSavedPlaces((prevPlaces) => {
      const updatedPlaces = [...prevPlaces];
      updatedPlaces.pop(); // Remove the last element
      if (updatedPlaces.length === 0){
        setPreviewVisible(false);
      }
      return updatedPlaces;
    });
  };

  const handleDocumentIdChange = (e) => {
    setDocumentId(e.target.value);
  };
  const handleRemovePlaceByIndex = (indexToRemove) => {
    setSavedPlaces((prevPlaces) => {
      if (indexToRemove >= 0 && indexToRemove < prevPlaces.length) {
        const updatedPlaces = [...prevPlaces];
        updatedPlaces.splice(indexToRemove, 1); // Remove the place at the specified index
        if (updatedPlaces.length === 0) {
          setPreviewVisible(false);
        }
        return updatedPlaces;
      } else {
        alert('Invalid index');
        return prevPlaces;
      }
    });
  };
  const handleSubmitButtonClick = async () => {
    // Check if any required field is empty
      if (!documentId || !busNumber || !driverMobileNumber) {
        alert('Please fill in all required fields.');
        return;
      }
      if(savedPlaces.length < 2){
        alert("Need atleast 2 Station details");
        return;
      }
      if (driverMobileNumber.length !== 10){
        alert("Enter valid 10-digit number")
        return;
      }
      const user = auth.currentUser;
    if (!user) {
      alert('User not authenticated');
      Navigate('/');
      return;
    }
    const userEmail = user.email;
    if (!userEmail) {
      alert('User does not have an email associated with their account');
      return;
    }
      const docRef = doc(firestore, 'Localbuses', documentId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const userConfirmation = window.confirm('Data already exists. Do you want to replace it?');
        if (!userConfirmation) {
          return;
        }
      }
      try {
        const journeyDetails = {
          busNumber,
          driverMobileNumber,
          Stations: savedPlaces,
          userEmail,
        };
        const phonenumbers = {
          driverMobileNumber,
        };          
        await setDoc(doc(firestore, 'Localbuses', documentId), journeyDetails);
        await setDoc(doc(firestore, 'phonenumbers',driverMobileNumber), phonenumbers);   
        alert('Data added to Firestore successfully');
      } catch (error) {
        alert('Error adding data to Firestore: ', error);
      }
  };
  

  return (
    <div className="custom-container">
    <div>
      <div id="map" className="left-half" />
      <div className="input-container right-half">
      <div>
    <input
      type="text"
      placeholder="Enter city name"
      value={cityInput}
      onChange={handleCityInputChange}
    />
  </div>
  <ul>
    {suggestions.map((suggestion, index) => (
      <li key={index} onClick={() => handleSuggestionClick(suggestion.coordinates, suggestion.placeName)}>
        {suggestion.placeName}
      </li>
    ))}
  </ul>
  <div className="input-row">
    <input type="text" placeholder="Place Name" value={placeDetails.placeName} onChange={(e) => setPlaceDetails({ ...placeDetails, placeName: e.target.value })} />
    <div className="btn-container">
      <button onClick={handleAddButtonClick} className='btn-round'>+</button>
      <button onClick={handleRemoveButtonClick} className='btn-round'>-</button>
    </div>
  </div>
  <div className="input-button-container">
  <input
    type="text"
    placeholder="Journey Unique ID"
    value={documentId}
    onChange={handleDocumentIdChange}
    className="input-document-id"
  />
  <button onClick={handleSubmitButtonClick} className='btn'>Submit</button>
</div>
<div className="input-button-container">
            <input
              type="text"
              placeholder="Enter Bus Number"
              value={busNumber}
              onChange={(e) => setBusNumber(e.target.value)}
              className="input-document-id" />
            <input
              type="tel"
              placeholder="Enter Driver Mobile Number"
              value={driverMobileNumber}
              onChange={(e) => setDriverMobileNumber(e.target.value)}
              className="input-document-id"
              pattern="[0-9]{10}" />
              <input
                type="number"
                placeholder="SlNo to remove station"
                className="input-remove-index"
                onChange={(e) => setRemoveIndex(parseInt(e.target.value -1 , 10))}
              />
              <button
                onClick={() => handleRemovePlaceByIndex(removeIndex)}
                className='btn-round'>
                Remove
              </button>
          </div>
{(!isPreviewVisible) && (
  <ul>
    <h3> Steps to add locations: </h3>
    <li> Search for the Place name in top of search bar and select the required name.</li>
    <li> Place the pin pointing to required position more accurately </li>
    <li> Can rename place where pin is pointing from the Second Text box. </li> 
    <li>Make sure to end place name with city name easy identification </li>
    <li> click '+' button to add place details.</li>
    <li> click '-' button to remove the recently added place. </li>
    <li> Enter 10 digit Driver Number </li>
    <li> Enter the Bus number (i.e., Either Bus Number or Place Number) </li>
    <li> Enter Unique Document id for identification and click on Submit </li>
  </ul>
)}

  {isPreviewVisible && (
  <div className="preview-container">
    <h3>Preview:</h3>
    <div className="scroll-table-container">
      <table className='custom-table'>
        <thead>
          <tr>
            <th>Sl No</th>
            <th>Place Name</th>
            <th>Latitude</th>
            <th>Longitude</th>
          </tr>
        </thead>
        <tbody>
          {savedPlaces.map((savedPlace, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{savedPlace.placeName}</td>
              <td>{savedPlace.latitude}</td>
              <td>{savedPlace.longitude}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    
  </div>
)}

</div>
    </div>
    </div>
  );
};

export default Collegebus;